import Promise from './promise'

const defaultOptions = {
  timeout: 8000,
  onCancel: () => {}
}

export default function preloadImage(src, options = {}) {
  const { timeout, onCancel } = { ...defaultOptions, ...options }

  let img

  const clean = () => img && (img.onload = img.onerror = null)

  const cancel = () => img && (img.src = '', onCancel())

  const promise = new Promise((resolve, reject) => {
    img = new Image
    img.onload = () => (clean(), resolve({ src, img }))
    img.onerror = () => (clean(), reject())
    img.src = src
    // 超时自动 cancel，给 img 赋值空串会 cancel
    timeout > 0 && setTimeout(() => {
      cancel()
      // 自动超时会 reject，主动 cancel 不会
      clean()
      reject()
    }, timeout)
  })

  promise.cancel = cancel

  return promise
}
